import script from "./RowOfMustardOildKhataBook.vue?vue&type=script&setup=true&lang=js"
export * from "./RowOfMustardOildKhataBook.vue?vue&type=script&setup=true&lang=js"

import "./RowOfMustardOildKhataBook.vue?vue&type=style&index=0&id=ab0b06c0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab0b06c0"]])

export default __exports__